import React from "react";
import BookingForm from "../components/BookingForm";



const DelRio = () => {
    return (
        <div className="bg-[#F2F1F0] text-[#144E73] font-sans min-h-screen pt-16 pb-20 px-6">
            <div className="max-w-6xl mx-auto">
                {/* Title */}
                <h1 className="text-4xl md:text-5xl font-bold text-primarymb-10 text-center">
                    Vanderbijlpark – Del Rio – Contractor Accommodation
                </h1>

                {/* Gallery + Description */}
                <div className="grid md:grid-cols-2 gap-10 mb-16 items-start">
                    {/* Gallery */}
                    <div className="grid grid-rows-[auto_1fr] gap-4">
                        <img
                            src="placeholder image.png"
                            alt="Del Rio Main"
                            className="w-full h-full object-cover border-4 border-[#FEB339]"
                        />
                        <div className="grid grid-cols-2 gap-4">
                            {[...Array(6)].map((_, i) => (
                                <img
                                    key={i}
                                    src="placeholder image.png"
                                    alt={`Del Rio Gallery ${i + 1}`}
                                    className="rounded-lg aspect-[4/3] object-cover border-4 border-[#FEB339]"
                                />
                            ))}
                        </div>
                    </div>

                    {/* Description */}
                    <div>
                        <p className="text-lg leading-relaxed mb-4">
                            Del Rio offers affordable and practical accommodation options designed with contractors and working teams in mind. It’s an ideal space for long-term stays in Vanderbijlpark, offering secure parking and shared living arrangements.
                        </p>
                        <ul className="list-disc ml-5 text-sm space-y-2">
                            <li>Budget-friendly for workers and teams</li>
                            <li>Long-stay accommodation available</li>
                            <li>Secure on-site parking</li>
                            <li>Multiple beds per unit</li>
                            <li>Shared facilities (where applicable)</li>
                        </ul>

                       
                    </div>
                </div>


                {/* Booking Form */}

                <BookingForm hotelName="Del Rio"/>

            </div>
        </div>
    );
};

export default DelRio;
